var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDockerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 261,
    viewBox: "0 0 260 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5212)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36.8906,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 37.3906,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.842 117.695C178.571 117.48 176.039 115.568 170.699 115.568C169.29 115.574 167.883 115.695 166.492 115.929C165.459 108.846 159.603 105.393 159.34 105.238L157.907 104.411L156.964 105.772C155.783 107.6 154.921 109.615 154.415 111.731C153.459 115.775 154.04 119.572 156.094 122.819C153.614 124.201 149.635 124.541 148.83 124.571H82.9584C81.2378 124.574 79.8417 125.964 79.8323 127.685C79.7555 133.455 80.7332 139.191 82.7173 144.611C84.9864 150.562 88.3623 154.945 92.7543 157.628C97.6759 160.642 105.672 162.364 114.736 162.364C118.831 162.377 122.917 162.006 126.943 161.258C132.539 160.23 137.924 158.274 142.875 155.47C146.954 153.108 150.626 150.103 153.747 146.57C158.966 140.662 162.075 134.083 164.387 128.236H165.309C171.022 128.236 174.536 125.949 176.474 124.033C177.761 122.811 178.767 121.322 179.419 119.671L179.828 118.474L178.842 117.695Z",
    fill: "#2496ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0642 122.642H97.8912C98.317 122.642 98.6619 122.297 98.6619 121.871V114.008C98.6643 113.583 98.3212 113.236 97.8956 113.233C97.8942 113.233 97.8926 113.233 97.8912 113.233H89.0642C88.6384 113.233 88.2935 113.579 88.2935 114.004V114.008V121.871C88.2935 122.297 88.6384 122.642 89.0642 122.642Z",
    fill: "#2496ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.228 122.642H110.055C110.481 122.642 110.826 122.297 110.826 121.871V114.008C110.828 113.583 110.485 113.236 110.06 113.233C110.058 113.233 110.057 113.233 110.055 113.233H101.228C100.8 113.233 100.453 113.58 100.453 114.008V121.871C100.456 122.297 100.802 122.642 101.228 122.642Z",
    fill: "#2496ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.577 122.642H122.405C122.83 122.642 123.175 122.297 123.175 121.871V114.008C123.178 113.583 122.834 113.236 122.409 113.233C122.407 113.233 122.406 113.233 122.404 113.233H113.577C113.152 113.233 112.807 113.579 112.807 114.004V114.008V121.871C112.807 122.297 113.152 122.642 113.577 122.642Z",
    fill: "#2496ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.78 122.642H134.608C135.034 122.642 135.38 122.298 135.383 121.871V114.008C135.383 113.58 135.036 113.233 134.608 113.233H125.78C125.355 113.233 125.01 113.579 125.01 114.004V114.008V121.871C125.01 122.297 125.355 122.642 125.78 122.642Z",
    fill: "#2496ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.228 111.33H110.055C110.482 111.328 110.826 110.981 110.826 110.555V102.693C110.826 102.267 110.481 101.922 110.055 101.922H101.228C100.802 101.922 100.456 102.266 100.453 102.693V110.555C100.456 110.982 100.801 111.328 101.228 111.33Z",
    fill: "#2496ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.577 111.33H122.404C122.831 111.328 123.175 110.981 123.175 110.555V102.693C123.175 102.267 122.83 101.922 122.404 101.922H113.577C113.152 101.922 112.807 102.267 112.807 102.693V110.555C112.807 110.981 113.151 111.328 113.577 111.33Z",
    fill: "#2496ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.78 111.33H134.608C135.035 111.328 135.38 110.982 135.383 110.555V102.693C135.38 102.266 135.034 101.922 134.608 101.922H125.78C125.355 101.922 125.01 102.267 125.01 102.693V110.555C125.01 110.981 125.354 111.328 125.78 111.33Z",
    fill: "#2496ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.78 100.015H134.608C135.034 100.015 135.38 99.6704 135.383 99.2442V91.3771C135.38 90.9507 135.034 90.6064 134.608 90.6064H125.78C125.355 90.6064 125.01 90.9514 125.01 91.3771V99.244C125.01 99.6697 125.355 100.015 125.78 100.015Z",
    fill: "#2496ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.091 122.642H146.918C147.345 122.642 147.691 122.298 147.693 121.871V114.008C147.693 113.58 147.346 113.233 146.918 113.233H138.091C137.665 113.233 137.32 113.579 137.32 114.004V114.008V121.871C137.32 122.297 137.665 122.642 138.091 122.642Z",
    fill: "#2496ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5212",
    x: 0,
    y: 0.890625,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5212",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerIcon);
export default __webpack_public_path__ + "static/media/docker-icon.4526088786f6afa733aa1a5c8e103f63.svg";
export { ForwardRef as ReactComponent };